// extracted by mini-css-extract-plugin
module.exports = {"external-link":"link-module__external-link___2Ulv3","externalLink":"link-module__external-link___2Ulv3","connect":"link-module__connect___3uqoF"};